import { Callout } from "fumadocs-ui/components/callout";
import { Lightbulb } from "lucide-react";
import type { ReactNode } from "react";

type CalloutProps = {
  children?: ReactNode;
};

export function Note({ children }: CalloutProps) {
  return (
    <Callout type="info" className="docs-callout">
      {children}
    </Callout>
  );
}

export function Tip({ children }: CalloutProps) {
  return (
    <Callout type="success" icon={<Lightbulb />} className="docs-callout">
      {children}
    </Callout>
  );
}

export function Info({ children }: CalloutProps) {
  return (
    <Callout type="info" className="docs-callout">
      {children}
    </Callout>
  );
}

export function Warning({ children }: CalloutProps) {
  return (
    <Callout type="warn" className="docs-callout">
      {children}
    </Callout>
  );
}
